module.exports = __webpack_public_path__ + "media/images/icon-chart-up-gray-34a9c3cc8621e9e924d85839297af24a.svg";